import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useClientId } from '../../_hooks/useClientId';
import { TabSlug } from '../types';

export type WidgetId =
  | 'market-value'
  | 'return'
  | 'activity-summary'
  | 'pv-vs-nai'
  | 'allocation-slot-a'
  | 'allocation-slot-b'
  | 'performance-summary'
  | 'performance-vs-benchmark'
  | 'performance-details'
  | 'projected-income'
  | 'income-details'
  | 'performance-chart';

export interface WidgetDTO {
  id: WidgetId;
  title: string;
  description: string;
  isFullWidth: boolean;
  isWidthAdjustable: boolean;
  rank: number;
}

export interface WidgetsDTO {
  included: WidgetDTO[];
  excluded: WidgetDTO[];
}

interface FetcherProps {
  clientId: number;
  tab: TabSlug;
}

const fetchWidgets = ({ clientId, tab }: FetcherProps): Promise<WidgetsDTO> => {
  return authFetch(urlWithParams('/Consumer/WidgetConfiguration', { clientId, tab }));
};

interface QueryParams {
  tab: TabSlug;
}

export const useWidgetsQuery = ({ tab }: QueryParams) => {
  const clientId = useClientId();

  return useQuery(
    queryKeys.widgets(clientId, tab),

    () => fetchWidgets({ clientId, tab }),

    {
      cacheTime: 0,
    },
  );
};
